const API_BASE = import.meta.env.VITE_API_URL ?? "";
const STORAGE_KEY = "fs-user";
const TOKEN_KEY = "fs-token";

const getAuthToken = () => {
  if (typeof window === "undefined") return null;
  const localToken = localStorage.getItem(TOKEN_KEY);

  if (localToken) return localToken;

  return sessionStorage.getItem(TOKEN_KEY);
};

const clearAuthStorage = () => {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new CustomEvent("auth:session-expired"));
};

export async function apiFetch<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const isFormData =
    typeof FormData !== "undefined" && options?.body instanceof FormData;
  const token = getAuthToken();
  const headers = new Headers(options?.headers ?? undefined);

  if (!isFormData && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    const contentType = response.headers.get("content-type") || "";
    let message = "Erreur API";

    if (contentType.includes("application/json")) {
      const data = (await response.json()) as { message?: string };

      message = data.message || message;
    } else {
      message = (await response.text()) || message;
    }
    if (response.status === 401 && token) {
      clearAuthStorage();
    }
    throw new Error(message);
  }

  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return response.json() as Promise<T>;
  }

  return Promise.resolve(null as T);
}
